/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Booking_Link_Not_SentInputs */

const en_error_booking_link_not_sent = /** @type {(inputs: Error_Booking_Link_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking links are not set up in this environment, or the email could not leave. Try again later.`)
};

/**
* | output |
* | --- |
* | "Booking links are not set up in this environment, or the email could not leave. Try again later." |
*
* @param {Error_Booking_Link_Not_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_booking_link_not_sent = /** @type {((inputs?: Error_Booking_Link_Not_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Booking_Link_Not_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_booking_link_not_sent(inputs)
});